export default __webpack_public_path__ + "static/media/setup.160659a6.jpg";